import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { SharedZoneBlocks, SharedZoneTags } from 'store/SharedZone/blocks/selectors';
import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import TagButtonList from 'bricks/TagButtonList';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

function TagsBlockLayout({ headline, headlineTagName, list, isMobile }) {
  return (
    <div className={cx('component')}>
      <TagButtonList
        headline={headline}
        headlineTagName={headlineTagName}
        list={list}
        isMobile={isMobile}
      />
    </div>
  );
}

TagsBlockLayout.propTypes = {
  headline: PropTypes.string,
  headlineTagName: PropTypes.string,
  list: PropTypes.array,
  isMobile: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  headline: SharedZoneTags.getHeadline(state),
  headlineTagName: SharedZoneTags.getHeadlineTagName(state),
  list: SharedZoneTags.getList(state),
  isMobile: isScreenBelow640(state),
});

export default SharedZoneBlocks.connect(mapStateToProps)(TagsBlockLayout);
